import { DataTable } from "@marketplace/ui/data-table";

import { useSellerListTableColumns } from "../../hooks/use-seller-list-table-columns";
import type { SellerListItem } from "../../types";

type SellerListTableProps = {
  records: SellerListItem[];
};

export const SellerListTable: React.FC<SellerListTableProps> = ({
  records
}) => {
  const { columns } = useSellerListTableColumns();

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
